import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { label: '首页', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', to: '/' },
  { label: '分类', icon: 'ri-layout-grid-line', activeIcon: 'ri-layout-grid-fill', to: '/category/movie' },
  { label: '搜索', icon: 'ri-search-line', activeIcon: 'ri-search-line', to: '/search' },
  { label: '社区', icon: 'ri-chat-smile-2-line', activeIcon: 'ri-chat-smile-2-fill', to: '/community' },
];

export default function MobileTabBar() {
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (to.startsWith('/category')) return location.pathname.startsWith('/category') || location.pathname.startsWith('/detail');
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden">
      <div className="grid grid-cols-4">
        {tabs.map((tab) => {
          const active = isActive(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center gap-1 py-2.5 text-xs transition-colors ${
                active ? 'text-primary-600' : 'text-foreground-400'
              }`}
            >
              <i className={`${active ? tab.activeIcon : tab.icon} text-xl`} />
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}